import { render, staticRenderFns } from "./MarketPrefix.vue?vue&type=template&id=092fe253&scoped=true&"
import script from "./MarketPrefix.vue?vue&type=script&lang=js&"
export * from "./MarketPrefix.vue?vue&type=script&lang=js&"
import style0 from "./MarketPrefix.vue?vue&type=style&index=0&id=092fe253&prod&lang=css&"
import style1 from "./MarketPrefix.vue?vue&type=style&index=1&id=092fe253&prod&lang=scss&"
import style2 from "./MarketPrefix.vue?vue&type=style&index=2&id=092fe253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092fe253",
  null
  
)

export default component.exports